// extracted by mini-css-extract-plugin
module.exports = {"LegendHeader":"Legend_LegendHeader__godU/"};